import React, { useState } from 'react';
const FeaturedProjectsSection = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const projects = [{
    id: 1,
    title: 'Luxury Home Theater',
    category: 'home-theater',
    image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    description: 'Custom 120" projection screen with Dolby Atmos surround sound and integrated smart home controls.'
  }, {
    id: 2,
    title: 'Restaurant Multi-Zone Audio',
    category: 'commercial',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    description: 'Six-zone audio system with central control for a high-end dining establishment.'
  }, {
    id: 3,
    title: 'Residential Camera Systems',
    category: 'surveillance',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/n6AXrUuoKJAM9nBRQDqAv4/camerasystems.jpg',
    description: 'Comprehensive 4K camera system with smart doorbell and remote monitoring capabilities.'
  }, {
    id: 4,
    title: 'Enterprise WiFi Network',
    category: 'network',
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    description: 'UniFi-based mesh network covering a 15,000 sq ft office building with seamless roaming.'
  }, {
    id: 5,
    title: 'Smart Home Automation',
    category: 'automation',
    image: 'https://images.unsplash.com/photo-1558002038-1055907df827?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    description: 'Comprehensive URC automation system integrating lighting, climate, protection, and entertainment.'
  }, {
    id: 6,
    title: 'Multi-Room Video Distribution',
    category: 'video',
    image: 'https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80',
    description: '4K video distribution system serving 8 displays throughout a luxury residence.'
  }];
  const categories = [{
    id: 'all',
    name: 'All Projects'
  }, {
    id: 'home-theater',
    name: 'Home Theater'
  }, {
    id: 'commercial',
    name: 'Commercial'
  }, {
    id: 'surveillance',
    name: 'Surveillance'
  }, {
    id: 'network',
    name: 'Networking'
  }, {
    id: 'automation',
    name: 'Automation'
  }, {
    id: 'video',
    name: 'Video'
  }];
  const filteredProjects = activeCategory === 'all' ? projects : projects.filter(project => project.category === activeCategory);
  return <section className="py-16 md:py-24 bg-white" data-id="element-103" data-mp="3viq1l0kjj9hh">
      <div className="container mx-auto px-4" data-id="element-104" data-mp="3vlcbh6uwm12v">
        <div className="text-center mb-12" data-id="element-105" data-mp="3qj3iiai16z0r">
          <p className="text-blue-600 font-semibold mb-2" data-id="element-106" data-mp="3qlzehtabjdmk">OUR PORTFOLIO</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-107" data-mp="3lmd0hhmo1tcp">
            Featured Projects
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-108" data-mp="n2eil7cyenk2">
            Explore our recent installations and see how we've helped clients
            transform their spaces with cutting-edge technology.
          </p>
        </div>
        {/* Category filter */}
        <div className="flex flex-wrap justify-center mb-12 gap-2" data-id="element-109" data-mp="8f1tx9ruo1pg">
          {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${activeCategory === category.id ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-110" data-mp="15upf8jh0lp9q">
              {category.name}
            </button>)}
        </div>
        {/* Projects grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-111" data-mp="bp4gyxudt83l">
          {filteredProjects.map(project => <div key={project.id} className="group" data-id="element-112" data-mp="14avwwk0ye6io">
              <div className="overflow-hidden rounded-xl shadow-md mb-4" data-id="element-113" data-mp="14c7atco44uni">
                <img src={project.image} alt={project.title} className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-114" data-mp="199774vv5uj1f" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-115" data-mp="zickvrhwzjfz">{project.title}</h3>
              <p className="text-gray-600" data-id="element-116" data-mp="1n8yrrfg6mxoe">{project.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FeaturedProjectsSection;